import { render, staticRenderFns } from "./topCenter.vue?vue&type=template&id=12820f2c&"
import script from "./topCenter.vue?vue&type=script&lang=js&"
export * from "./topCenter.vue?vue&type=script&lang=js&"
import style0 from "./topCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports